const removeDuplicate = (arr, key) =>
  arr.reduce((acc, current) => {
    const x = acc.find((item) => item[key] === current[key])
    if (!x) return acc.concat([current])
    return acc
  }, [])

export default removeDuplicate
